import { Checkbox, TableCell, TableRow } from "@mui/material";

interface ExcludedFeedPlateProps {
  runIndex: number;
  plateIndex: number;
  reason: string;
  plateWorklistInfo: {
    selected: boolean;
    activeWellCount: number;
    plateBarcode: string;
    plateID: number;
    aspirateVol: number;
    dispenseVol: number;
    aspirateLC: string;
    dispenseLC: string;
  };
  updateExcludedPlateSelection: (
    groupIndex: number,
    plateIndex: number
  ) => void;
}

export const ExcludedFeedPlate = ({
  runIndex,
  plateIndex,
  reason,
  plateWorklistInfo,
  updateExcludedPlateSelection,
}: ExcludedFeedPlateProps) => {
  return (
    <TableRow>
      <TableCell>
        <Checkbox
          checked={plateWorklistInfo.selected}
          onChange={(e) => updateExcludedPlateSelection(runIndex, plateIndex)}
          disabled={reason === "Exists in Active Reservation"}
        />
      </TableCell>
      <TableCell>{plateWorklistInfo.plateBarcode}</TableCell>
      <TableCell>{plateWorklistInfo.activeWellCount}</TableCell>
    </TableRow>
  );
};
